import { jsx as _jsx } from "react/jsx-runtime";
var Replay = function Replay(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.84191 12.5228C4.30692 12.5228 4.68382 12.8861 4.68382 13.3342C4.68382 17.2284 7.9594 20.3853 12 20.3853C16.0406 20.3853 19.3162 17.2284 19.3162 13.3342C19.3162 9.44004 16.0406 6.28314 12 6.28314H11.276L12.5949 7.55434C12.9351 7.85997 12.9539 8.37331 12.637 8.70112C12.3199 9.02893 11.7873 9.04705 11.4471 8.74169C11.4326 8.72871 11.4185 8.71492 11.4051 8.70112L8.68007 6.07488C8.50917 5.90828 8.42105 5.67838 8.43873 5.44469C8.42105 5.21074 8.50917 4.98111 8.68007 4.81451L11.4022 2.19097C11.7578 1.90211 12.2891 1.94593 12.5885 2.28861C12.8503 2.58802 12.8531 3.02455 12.5949 3.32694L11.2198 4.65223H12C16.9706 4.65223 21 8.5356 21 13.3261C21 18.1166 16.9706 22 12 22C7.03274 22 3.00477 18.1215 3 13.3342C3 12.8861 3.37717 12.5228 3.84191 12.5228",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Replay;